import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { ITEM_HEIGHT, ProductStyled } from './CartProduct/styled'
import { PaymentProductsContainer, TableDiv } from './styled'
import { useTranslations } from 'featureSliced/shared/hooks/useTranslations'
import { GridDiv } from 'featureSliced/shared/utils/gridDiv'

const SKELETON_COLORS = {
  base: '#999999',
  highlight: '#898989',
  circleHeight: `${ITEM_HEIGHT}px`,
  textWidth: '75%',
  textMargin: '10px',
}

export const FakeCart = () => {
  const t = useTranslations()

  const FakeProduct = () => (
    <ProductStyled>
      <GridDiv gr="1 / -1" style={{ marginTop: '-4px' }}>
        <Skeleton
          circle
          baseColor={SKELETON_COLORS.base}
          highlightColor={SKELETON_COLORS.highlight}
          style={{ height: SKELETON_COLORS.circleHeight }}
        />
      </GridDiv>

      <GridDiv gr="1 / 2" gc="2 / 3">
        <Skeleton
          baseColor={SKELETON_COLORS.base}
          highlightColor={SKELETON_COLORS.highlight}
          style={{
            marginLeft: SKELETON_COLORS.textMargin,
            width: SKELETON_COLORS.textWidth,
          }}
        />
      </GridDiv>

      <GridDiv gr="2 / 3" gc="3 / -1">
        <Skeleton
          baseColor={SKELETON_COLORS.base}
          highlightColor={SKELETON_COLORS.highlight}
        />
      </GridDiv>
    </ProductStyled>
  )

  return (
    <>
      <TableDiv>{t('order.yourOrder')}</TableDiv>
      <PaymentProductsContainer>
        {[...Array(3)].map((_, i) => (
          <FakeProduct key={i} />
        ))}
      </PaymentProductsContainer>
    </>
  )
}
